module.exports = __webpack_public_path__ + "img/arch-2.0e296f14.png";